export default __webpack_public_path__ + "static/BZ_COBERTURADC_EP_R00-1_Pgina_02-6e8ea9339e57f075a21cd3e33260f1d9.jpg";